import { PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';
import { InputProps } from './Input.types';
import { Input } from 'antd';

import {
  space,
  layout,
  color,
  background,
  border,
  flexbox,
  grid,
  position,
  shadow,
  typography,
  compose,
} from 'styled-system';

export const InputBase = styled(Input)<InputProps>(
  ({ placeholderColor }) => css`
    /** Reset/Base  */
    width: 100%;
    height: 55px;
    color: #111;
    font-size: 16px;
    background-color: #fff;
    -webkit-box-shadow: 0 0 0 50px white inset;
    border-radius: 4px;
    border-color: rgba(127, 135, 182, .5);

    input {
      -webkit-box-shadow: 0 0 0 50px white inset;
      box-shadow: 0 0 0 50px white inset;
      border-color: rgba(127, 135, 182, .5);
    }
    
    &:focus,
    &:active {
      outline: none;
      border-color: rgba(127, 135, 182, 1);
    }

    &::placeholder {
      color: ${placeholderColor};
      opacity: 1; /* Firefox */
    }
  `,

  ({ shadow }) =>
    shadow &&
    css`
      box-shadow: 0px 4px 4px rgba(93, 103, 160, 0.15),
        0px 4px 16px rgba(93, 103, 160, 0.08);
    `,

  ({ shape }) =>
    shape === 'round' &&
    css`
      border-radius: 20px;
    `,

  compose(
    space,
    layout,
    color,
    background,
    border,
    flexbox,
    grid,
    position,
    shadow,
    typography
  )
);
